package com.essntl.features.task.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [TaskSupabaseDataSource::class])
internal class TaskSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<TaskDto> {
    override val tableName: String = "task"
}
